<template>
    <header>
        <div>您正在申請</div>
        <h1>百利好國際之交易賬戶</h1>
        <div>欲申請百利好國際有限公司之交易賬戶，您必須年滿十八歲，並同意申請過程之條款。</div>
    </header>
</template>

<script>
    export default {
        inherit: true,
        name: "banner",
        data () {
            return {
            }
        },
        components: {
        }
    }
</script>

<style lang="scss" scoped>
    $green: #33DB40;
    header{
        background: linear-gradient(rgba(0,80,130,0.75),rgba(0,80,130,0.75)), url(../assets/header-bg.jpg);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: 20% bottom;
        height: 325px;
        width: 100%;
        padding: 50px;
        box-sizing: border-box;
        line-height: 1.45;
        position: relative;
    }
    header > h1 {
        font-weight: bolder;
        color: white;
        text-align: left;
        font-size: 36px;
        margin: 0;
        line-height: 1.2;
    }
    header > div:first-child{
        color: $green;
    }
    header > div {
        font-size: 16px;
        text-align: justify;
    }
    header > div:last-child{
        color: white;
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 50px;
        padding: 0 50px;
        box-sizing: border-box;
    }
</style>
